<script>
import { exitFullScreen, formatResultFunc } from "@/common/util.js";
const mapEyes = {
  finallyEyes: "双眼",
  finallyRight: "右眼",
  finallyLeft: "左眼"
};
export default {
  data() {
    const key = this.$route.params.key;
    const path = this.$route.params.gamePath;
    return {
      path: `${this.$resourceUrl}/${path}/index.html`,
      key,
      finished: false,
      picInfo: undefined,
      showResultImg: false
    };
  },
  mounted() {
    this.$el.lastElementChild.lastElementChild.src = this.path;
    this.fullScreen();
    window.addEventListener("message", this.getMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.getMessage);
    exitFullScreen();
  },
  methods: {
    getMessage(e) {
      if (this.isJsonString(e.data)) {
        let data = e.data;
        data = JSON.parse(data);
        if (data.type === "saveBtnClicked") {
          // if (this.key === "CONTRAST_SENSITIVITY_TRAINING") {
          //   this.$router.replace("/index/homeRoute");
          //   this.saveFinshedResult(data.data);
          // } else {
          localStorage.setItem(this.key, JSON.stringify(data.data));
          this.saveFinshedResult(data.data);
          // }
        } else if (data.type === "getPixelInfo") {
          let messData = JSON.parse(localStorage.getItem("data"));
          document.querySelector(".ScreenIframe").contentWindow.focus();
          let jsonData = JSON.stringify({
            type: "getPixelInfo",
            data: messData
          });
          window.frames[0].postMessage(jsonData, "*");
          this.finished = true;
        } else if (data.type === "quit") {
          this.$router.replace("/index/homeRoute");
        } else if (data.type === "sendResult") {
          this.saveFinshedResult(data.data);
        } else if (data.type === "getImage") {
          this.showResultImg = true;
          this.$nextTick(() => {
            this.drawLine(data.data.data.finallyArr, data.data.data.normalArr);
          });
        }
      }
    },
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
          return true;
        }
      } catch (e) {}
      return false;
    },
    goBack() {
      this.$router.replace("/index/homeRoute");
    },
    fullScreen() {
      var element = this.$el.lastElementChild;
      var requestMethod =
        element.requestFullScreen || //W3C
        element.webkitRequestFullScreen || //FireFox
        element.mozRequestFullScreen || //Chrome等
        element.msRequestFullscreen; //IE11
      if (requestMethod) {
        requestMethod.call(element);
      }
    },
    async saveFinshedResult(testResult) {
      const data = formatResultFunc(this.key, testResult);
      console.log("save>>>>>>>>", data);
      const result = await this.$http.admin.saveTestResult(data);
      if (!result) {
        this.$message.warning("保存失败，请重新进行测试！");
      }
      if (this.$route.path !== "/index/homeRoute") {
        this.$router.replace("/index/homeRoute");
      }
    },
    drawLine(lineData, normalArr) {
      const shadowData = [
        ["3", normalArr[0][0]],
        ["6", normalArr[1][0]],
        ["12", normalArr[2][0]],
        ["18", normalArr[3][0]],
        ["18", normalArr[3][1]],
        ["12", normalArr[2][1]],
        ["6", normalArr[1][1]],
        ["3", normalArr[0][1]],
        ["3", normalArr[0][0]]
      ];
      const result = [];
      if (lineData.length > 0) {
        lineData.forEach(item => {
          const chartComponent = this.$refs.visionChallengeResult;
          const yData = item.data.map(o => {
            return ["" + o[0], o[1]];
          });
          let myChart = this.$echarts.init(chartComponent);
          myChart.setOption({
            title: {
              text: mapEyes[item.type],
              textStyle: {
                color: "#000000",
                fontSize: 14,
                fontWeight: 400
              }
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              name: "空间频率",
              nameLocation: "center",
              nameGap: 25,
              data: ["0", "3", "6", "12", "18", ""]
            },
            grid: {
              left: "15%",
              right: "0",
              bottom: "25%"
            },
            yAxis: {
              type: "value",
              name: "对比敏感度",
              nameLocation: "center",
              nameGap: 35
            },
            animation: false,
            series: [
              {
                data: shadowData,
                type: "line",
                areaStyle: {
                  color: "gray"
                },
                symbol: "none",
                lineStyle: {
                  color: "gray"
                }
              },
              {
                data: yData,
                type: "line",
                lineStyle: {
                  color: "green"
                }
              }
            ]
          });
          result.push(myChart.getDataURL());
        });
      }

      this.$nextTick(() => {
        var picInfo = result;
        this.picInfo = picInfo;
        if (picInfo) {
          let jsonData = JSON.stringify({
            type: "getImage",
            data: picInfo
          });
          window.frames[0].postMessage(jsonData, "*");
        }
        this.showResultImg = false;
      });
    }
  }
};
</script>
<template>
  <div
    class="TrainIframe"
    v-loading.fullscreen.lock="!finished"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div v-if="showResultImg" ref="visionChallengeResult" style="width: 300px;height: 200px;"></div>
    <div class="container">
      <iframe class="ScreenIframe" frameborder="no"></iframe>
    </div>
  </div>
</template>

<style lang="scss">
.TrainIframe .container {
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #00c1de;
  }
  .el-input__inner:focus {
    border-color: #00c1de;
  }
}
.container .LoadingView {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss" scoped>
.el-select-dropdown__item.selected {
  color: #00c1de;
}
.TrainIframe {
  width: 99%;
  height: 96%;
}
.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  flex-grow: 1;
  // margin: 15px;
  background-color: #fff;
  border-radius: 5px;
  //   overflow: auto;
}
.ScreenIframe {
  width: 100%;
  height: 100%;
}
.text {
  margin-bottom: 24px;
  margin: 0 23px 24px 23px;
  text-align: center;
  color: #343434;
  font-size: 18px;
  .selectBox {
    margin-top: 20px;
  }
}
</style>







// WEBPACK FOOTER //
// src/components/vision/basicIFrameView.vue